module.exports = __webpack_public_path__ + "img/diesel-locomotive-mask-03.ed87733f.png";